import { defineMessages } from "react-intl";

const messages = defineMessages({
    expired: {
        id: "warning.refreshAndReload",
    },
    unauthorized: {
        id: "warning.unauthorized",
    },
    reload: {
        id: "warning.reloadButton",
    },
    browserversion: {
        id: "supportError.browserversion",
    },
    osversion: {
        id: "supportError.osversion",
    },
    browser: {
        id: "supportError.browser",
    },
});

export default messages;
